import { post, fetch } from "@/ask/axios";
import menberMenu from "@/components/userCenter/public/menberPageMenu.vue";
import { getCustomer, setCustomer } from "@/utils/getCustomer";
import WorkGroup from "@/components/userCenter/public/basicInfo/workGroupList";
import UpdatePass from "@/components/userCenter/public/basicInfo/updatePass";
import myInvoice from "@/components/userCenter/myInfo/myInvoice.vue";
import airDelegate from "@/components/userCenter/myInfo/airDelegate.vue";
import { getCookie, delCookie, setCookie } from "@/ask/cookiejs";
import Vue from "vue";
import bus from "@/ask/eventBus";
export default {
  name: "basicInfo",
  components: { menberMenu, WorkGroup, UpdatePass, myInvoice, airDelegate },
  data() {
    return {
      //更改邮箱，手机号
      clkSurTrue: false, //是否可以点击新增
      validateBox: false,
      validateTitle: "Modify",
      updateInfo: {
        Mail: "",
        mailError: "",
        phoneNum: null,
        phoneError: "",
        code: "",
        codeError: "",
        type: 0, //1 邮箱, 2 手机
      },
      WaitTime: 0, //获取邮箱，手机号倒计时
      timer: null,

      updateInfoRules: {
        Mail: [
          {
            required: true,
            message: "Please enter a valid email number",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter a valid email number",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "The length is less than 50 characters",
            trigger: "blur",
          },
        ],
        phoneNum: [
          { required: true, message: "请输入有效手机号", trigger: "blur" },
          { pattern: /^\d{11}$/, message: "请输入有效手机号", trigger: "blur" },
        ],
        code: [
          {
            required: true,
            message: "Please enter verification code",
            trigger: "blur",
          },
        ],
      },
      rules: {
        CustomerName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 100, message: "长度在100个字符以内", trigger: "blur" },
        ],
        Mail: [
          {
            required: true,
            message: "Please enter a valid email number",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter a valid email number",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "The length is less than 50 characters",
            trigger: "blur",
          },
        ],
        MobilePhone: [
          { pattern: /^[0-9-]+$/, message: "手机格式不正确", trigger: "blur" },
          { min: 1, max: 15, message: "长度在15个字符以内", trigger: "blur" },
        ],
        Position: [
          { required: true, message: "请输入职位", trigger: "blur" },
          { min: 1, max: 100, message: "长度在50个字符以内", trigger: "blur" },
        ],
      },

      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: "",
      },
      titNames: "Basic Info",
      titUrls: ",",
      Edlit: false,
      showModal: false,
      IsPassword: false,
      Account: false,
      showAddChild: false,

      //判断密码是否输入
      IsPassword1: false,
      Psaaword: "",
      PasswordMsg: "",
      // -----------------
      addrConsigneeList: [], //收件人地址库
      fromConsigneeAddr: {
        //City和Country的数据
        Country_Key: "",
      },
      countryOptions: [], //海外国家下拉数据
      loading: false,
      // ————————————————————

      PhoneReg: true, //当Phone输入后，就需要判断
      PhoneMsg: "format error",

      IsPassword2: false,
      NewPassword: "",
      PasswordMsg2: "",

      IsPassword3: false,
      Passwordxin: "",
      PasswordMsg3: "",

      Name: "",
      NameMsg: "",
      IsName: false,

      Phone: "",
      PhoneFlag: false,

      UserInfo: {},
      CompyInfo: {},
      // Country的提示信息
      Country: "",
      CountryMsg: "Country is required",
      // City的提示信息
      City: "",
      CityMsg: "City is required",
      ProvinceNameMsg: "",
      ZipCodeMsg: "",
      ProvinceName: "",
      ZipCode: "",

      // 控制save按钮的点击显示
      saveFlag: false,
      Address: "",
      ShowAddress: "",
      AddressMsg: "Address is required",

      workGroup: {}, //列表显示
      nextId: [], //传到下级去的  当前展开id的集合
      level: "", //当前等级
      isMaster: false, //当前等级
      isNextAss: [],
      needLineData: true, //不需要线条
      curUser: {}, //当前账号信息

      isTrueRootCustomer: true,
      sendFlag: true,
      userType: 0,//是否海外同行  客户归属类型 0：直客，1：国内同行，2：海外同行 3:对接平台客户
      myHeaders: {
        ["X-JWT-TOKEN"]: getCookie("X-BY-EnTOKEN"),
      },
      templateData: {
        PathName: "UserImage",
        IsTempFile: false,
      }, // 上传附件参数
      uploadStatus: 1, // 1： 默认， 2： 成功， 3： 失败
      companyLogoImg: "",
    };
  },

  computed: {
    // 页面上显示的Address地址格式
    getAddrsee() {
      let ProvincesName = "";
      let PostCode = "";
      let CountryName = "";
      let AddressInfo = "";
      let CityName = "";
      // this.countryOptions.forEach((element) => {
      //   if (element.CountryKey === this.CompyInfo.CountryKey) {
      //     CountryName = element.NameEn;
      //   }
      // });
      CountryName = this.CompyInfo.Country;
      if (!this.CompyInfo.ProvincesName) {
        ProvincesName = "";
      } else {
        ProvincesName = this.CompyInfo.ProvincesName + ", ";
      }
      if (!this.CompyInfo.PostCode) {
        PostCode = "";
      } else {
        PostCode = this.CompyInfo.PostCode + ", ";
      }
      if (!this.CompyInfo.AddressInfo) {
        AddressInfo = "";
      } else {
        AddressInfo = this.CompyInfo.AddressInfo + ", ";
      }
      if (!this.CompyInfo.CityName) {
        CityName = "";
      } else {
        CityName = this.CompyInfo.CityName + ", ";
      }
      return AddressInfo + CityName + ProvincesName + PostCode + CountryName;
    },
  },
  created() {
    //创建后
    this.getUserInfo();
    this.GetUsercompy();
    this.getReceivesList(); //收件人地址列表接口数据
    this.getCountryInfo();
  },
  mounted() {

    this.userType = JSON.parse(
      sessionStorage.getItem("customerInfos")
    ).CustomerOwnerType;

    this.myHeaders["X-JWT-TOKEN"] = getCookie("X-BY-EnTOKEN");
  },
  watch: {
    //修改邮箱，手机号
    "updateInfo.Mail": function (newVal, oldVal) {
      if (!newVal || newVal) {
        this.updateInfo.mailError = "";
        this.rules.Mail[0].required;
      }
    },
    "updateInfo.phoneNum"(newVal, oldVal) {
      if (!newVal || newVal) {
        this.updateInfo.phoneError = "";
      }
    },
    "updateInfo.code": function (newVal, oldVal) {
      if (!newVal || newVal) {
        this.updateInfo.codeError = "";
      }
    },
  },
  methods: {
    // 删除公司logo
    deleteCompanyLogo() {
      // 提示
      this.$confirm(
        "Are you sure to delete the logo?",
        "hint",
        {
          customClass: "customClassConfirmWarning",
          cancelButtonText: "Cancel",
          confirmButtonText: "Yes",
          type: "warning",
        }
      ).then(() => {
        let url = this.$api04 + "/Basics/api/CustomerInfo/DelCompanyLogo";
        let param = {

        };

        post(url, param)
          .then((res) => {
            if (res.IsOK) {
              this.uploadStatus = 1;
              this.companyLogoImg = "";
              bus.$emit('updateCompanyLogo', "");
            } else {
              this.$message({
                type: "error",
                message: res.Message,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });

      }).catch(() => {

      });

    },
    // 附件上传格式限制
    uploadFileLimit(file) {
      this.isLoading = true;
      // this.uploadStatus = 1;
      const extension = ".jpg, .jpeg, .png, .bmp, ";
      var fileName = file.name;
      var ext =
        fileName.substring(fileName.lastIndexOf("."), fileName.length) + ", ";
      ext = ext.toLowerCase();

      console.log(ext, "ext");
      if (extension.indexOf(ext) == -1) {
        this.$confirm("Only files in jpg, bmp, png, and jpeg formats are supported.", "hint", {
          customClass: "customClassConfirmWarning",
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          showCancelButton: false, //去掉取消按钮
          showClose: false, //去掉右上角的取消（X）
          type: "warning",
          center: true,
        });
        this.isLoading = false;
        return false;
      }

      // let isLt3M = file.size / 1024 / 1024 < 3;
      let isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$confirm("Each file should not exceed 20M in size.", "hint", {
          customClass: "customClassConfirmWarning",
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          showCancelButton: false, //去掉取消按钮
          showClose: false, //去掉右上角的取消（X）
          type: "warning",
          center: true,
        });
        return false;
      }

      // const isLtZeroM = file.size / 1024 / 1024 > 0;
      // if (!isLtZeroM) {
      //   this.$confirm("文件大小为0kb,请重新上传！", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     showCancelButton: false, //去掉取消按钮
      //     showClose: false, //去掉右上角的取消（X）
      //     type: "warning",
      //     center: true,
      //   });
      //   return false;
      // }
      //上传文件名不能超多100个字符
      // if (fileName.length > 100) {
      //   this.$confirm("文件名超过100个字符，请重新上传！", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     showCancelButton: false, //去掉取消按钮
      //     showClose: false, //去掉右上角的取消（X）
      //     type: "warning",
      //     center: true,
      //   });
      //   this.isLoading = false;
      //   return false;
      // }
    },
    // 附件上传成功事件
    uploadFileSuccess(response, file, fileList) {
      if (response.Results.UploadPath) {
        // 导入
        let url = this.$api04 + "/Basics/api/CustomerInfo/SaveCompanyLogoImg";
        let param = {
          companyLogoImg: response.Results.UploadPath,
        };

        post(url, param)
          .then((res) => {
            this.isLoading = false;
            if (res.IsOK) {
              this.uploadStatus = 2;
              this.companyLogoImg = response.Results.UploadPath;
              bus.$emit('updateCompanyLogo', response.Results.UploadPath);
            } else {
              this.uploadStatus = 4;
              this.$message({
                type: "error",
                message: res.Message,
              });
            }
          })
          .catch((err) => {
            this.isLoading = false;
            console.log(err);
          });
        //
      }
    },
    uploadFileFailed(err, file, fileList) {
      console.log(err);
      this.isLoading = false;
      this.uploadStatus = 3;
    },
    hrefCheck() {
      this.$router.push({
        path: "/reg/emailAct",
        query: {
          Email: this.UserInfo.Mail,
        },
      });
    },
    initfunction() {
      let that = this;
      // this.api.url = this.$api02 + "/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.url =
        this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.param = {};
      post(this.api.url, this.api.param).then((res) => {
        if (res.Results) {
          if (!res.Results.RootCustomerInfo) {
            that.isTrueRootCustomer = true;
            that.UserInfo.CustomerName = res.Results.CustomerName;
            that.UserInfo.RootCustomerID = res.Results.RootCustomerID;
            that.UserInfo.UserHeadImg = res.Results.UserHeadImg;

            that.UserInfo.ProvincesKey = res.Results.ProvincesKey;
            that.UserInfo.ProvincesName = res.Results.ProvincesName;
            that.UserInfo.CityKey = res.Results.CityKey;
            that.UserInfo.CityName = res.Results.CityName;
            that.UserInfo.AreaKey = res.Results.AreaKey;
            that.UserInfo.AreaName = res.Results.AreaName;

          } else {
            that.isTrueRootCustomer = false;
            //如果是子账号登录  头像、用户名、地址，显示的是主账号的，邮箱和手机号是子账号的
            that.UserInfo.CustomerName =
              res.Results.RootCustomerInfo.CustomerName;
            that.UserInfo.RootCustomerID =
              res.Results.RootCustomerInfo.RootCustomerID;
            that.UserInfo.UserHeadImg =
              res.Results.RootCustomerInfo.UserHeadImg;

            that.UserInfo.ProvincesKey =
              res.Results.RootCustomerInfo.ProvincesKey;
            that.UserInfo.ProvincesName =
              res.Results.RootCustomerInfo.ProvincesName;
            that.UserInfo.CityKey = res.Results.RootCustomerInfo.CityKey;
            that.UserInfo.CityName = res.Results.RootCustomerInfo.CityName;
            that.UserInfo.AreaKey = res.Results.RootCustomerInfo.AreaKey;
            that.UserInfo.AreaName = res.Results.RootCustomerInfo.AreaName;
          }
          that.UserInfo.Level = res.Results.Level;
          that.UserInfo.Email = res.Results.Mail;
          that.UserInfo.Mobile = res.Results.MobilePhone;
          console.log(res.Results, 'res1');

        }
      });
    },
    //编辑地址
    clkAddr() {
      this.addrShow = false;
    },
    //编辑邮箱
    clkEditBasic(code) {
      this.updateInfo.type = code;
      code == 1
        ? (this.validateTitle = "Modify")
        : (this.validateTitle = "修改手机");
      this.validateBox = true;
    },

    mailCodeApi() {
      let that = this;
      if (!this.updateInfo.Mail) {
        this.updateInfo.mailError = "Please enter a valid email number";
        return false;
      }
      // let url=this.$api02+'/api/EbayCustomer/CustomerInfo/UpdateEmailSendEmail';
      let url =
        this.$api04 +
        `/Air/api/Email/UpdateEmailSendEmail?Email=${this.updateInfo.Mail}`;
      let param = {
        Email: this.updateInfo.Mail,
      };
      post(url, param)
        .then((res) => {
          if (res.IsOK) {
            that.getSecond();
          } else {
            that.updateInfo.mailError = res.Message;
          }
        })
        .catch((err) => {
          that.$message.error("Service error");
        });
    },
    phoneCodeApi() {
      let that = this;
      if (!this.updateInfo.phoneNum) {
        this.updateInfo.phoneError = "请输入有效手机号";
        return false;
      }

      let url =
        // this.$api02 +
        // "/api/EbayCustomer/MobileCode/GenerateMobileCodeEditPhone";
        this.$api04 + "/Basics/api/MobileCode/GenerateMobileCodeEditPhone";
      let param = {
        mobile: this.updateInfo.phoneNum,
      };
      fetch(url, param).then((res) => {
        if (res.IsOK) {
          that.getSecond();
        } else {
          that.updateInfo.phoneError = res.Message;
        }
      });
    },

    getSecond() {
      let TIME_COUNT = 60;
      this.sendFlag = false;
      if (!this.timer) {
        this.WaitTime = TIME_COUNT;
        let that = this;
        this.timer = setInterval(() => {
          if (that.WaitTime > 0 && that.WaitTime <= TIME_COUNT) {
            that.WaitTime--;
          } else {
            that.WaitTime = 0;
            that.sendFlag = true;
            clearInterval(that.timer);
            that.timer = null;
          }
        }, 1000);
      }
    },
    //停止倒计时
    stopCount() {
      this.WaitTime = 0;
      this.sendFlag = true;
      this.timer = null;
      clearInterval(this.timer); //清除
    },

    clkCommitBtn(formName) {
      //提交修改邮箱，手机号
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.updateInfo.type == 1) {
            //修改邮箱
            this.clkrMail();
          } else if (this.updateInfo.type == 2) {
            //修改手机
            this.clkMobile();
          }
        } else {
          return false;
        }
      });
    },

    clkSendCode() {
      //发送验证码

      this.$refs["updateRuleForm"].validateField("phoneNum", (valid) => {
        //valid返回的是规则集中写的错误提示信息，如果满足条件，返回的就是空
        if (!valid) {
          if (this.updateInfo.type == 2) {
            this.phoneCodeApi();
          }
        }
      });

      this.$refs["updateRuleForm"].validateField("Mail", (valid) => {
        //valid返回的是规则集中写的错误提示信息，如果满足条件，返回的就是空
        if (!valid) {
          if (this.updateInfo.type == 1) {
            this.mailCodeApi();
          }
        }
      });
    },

    clkrMail() {
      let that = this;
      // this.api.url=this.$api02+'/api/EbayCustomer/CustomerInfo/UpdateMail';
      this.api.url = this.$api04 + "/Air/api/Email/UpdateMail";

      this.api.param = {
        mail: this.updateInfo.Mail,
        mailCode: this.updateInfo.code,
      };
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK) {
          //调用基本资料接口
          // that.initfunction();
          // this.UpdateUserInfo();
          this.UserInfo.Mail = this.updateInfo.Mail;
          this.getUserInfo();
          console.log(232323232);
          that.validateBox = false;
          // that.getWorkGroup()

          that
            .$confirm("Modify the email successfully！", "Tips", {
              customClass: "custom-message-box", //自定义添加Class
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
              closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
              showCancelButton: false, //去掉取消按钮
              showClose: false, //去掉右上角的取消（X）
              // type: 'warning',
              center: true,
            })
            .then(() => { })
            .catch(() => { });
          return false;
        } else {
          if (res.ErrorCode == "C0014") {
            that.updateInfo.codeError = res.Message;
          } else if (res.ErrorCode == "C0013") {
            that.updateInfo.mailError = res.Message;
          } else {
            that
              .$confirm(res.Message, "Tips", {
                customClass: "custom-message-box", //自定义添加Class
                confirmButtonText: "Confirm",
                cancelButtonText: "Cancel",
                cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                showCancelButton: false, //去掉取消按钮
                showClose: false, //去掉右上角的取消（X）
                // type: 'warning',
                center: true,
              })
              .then(() => { })
              .catch(() => { });
            return false;
          }
        }
      });
    },

    clkMobile() {
      let that = this;
      // this.api.url=this.$api02+'/api/EbayCustomer/CustomerInfo/UpdateCustomerPhone';
      // this.api.url = this.$api04 + "/Air/api/Email/UpdateMail";
      this.api.url =
        this.$api04 + "/Basics/api/CustomerInfo/UpdateCustomerPhone";
      this.api.param = {
        Phone: this.updateInfo.phoneNum,
        PhoneCode: this.updateInfo.code,
      };
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK) {
          //调用基本资料接口
          // that.initfunction()
          //that.MobileIsShow=true
          // that.getWorkGroup()
          that.validateBox = false;

          that
            .$confirm("修改手机号成功！", "提示", {
              customClass: "custom-message-box", //自定义添加Class
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
              closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
              showCancelButton: false, //去掉取消按钮
              showClose: false, //去掉右上角的取消（X）
              // type: 'warning',
              center: true,
            })
            .then(() => { })
            .catch(() => { });
        } else {
          if (res.ErrorCode == "C0014") {
            that.updateInfo.codeError = res.Message;
          } else if (res.ErrorCode == "C0013") {
            that.updateInfo.phoneError = res.Message;
          } else {
            that
              .$confirm(res.Message, "提示", {
                customClass: "custom-message-box", //自定义添加Class
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                showCancelButton: false, //去掉取消按钮
                showClose: false, //去掉右上角的取消（X）
                // type: 'warning',
                center: true,
              })
              .then(() => { })
              .catch(() => { });
          }

          return false;
        }
      });
    },
    //取消编辑地址，邮箱，手机号
    clkCancel(m) {
      switch (m) {
        case 1:
          this.addrShow = true;
          // this.initfunction()
          break;
          // case 2:
          //     this.MailIsShow=true
          //     this.initfunction()
          // break;
          // case 3:
          //     this.MobileIsShow=true
          //     this.initfunction()
          break;
      }
    },
    clkClose() {
      //修改邮箱、手机号
      this.stopCount(); //倒计时归0
      this.updateInfo.code = "";
      this.updateInfo.mailError = "";
      this.updateInfo.phoneError = "";
      this.updateInfo.codeError = "";

      this.nameError = "";
      this.mailError = "";
      this.phoneError = "";
      //
    },

    // 关闭修改邮箱按钮
    closeModifyMail() {
      this.stopCount(); //倒计时归0
      this.updateInfo.mailError = "";
      this.updateInfo.codeError = "";
      this.updateInfo.Mail = "";
      this.updateInfo.code = "";
      // 重置表单
      this.$refs["updateRuleForm"].resetFields();
      this.validateBox = false;
    },
    //收件地址列表接口数据
    getReceivesList() {
      // this.api.url = this.$api02 + "/api/EbayCustomer/Addressee/List";
      this.api.url = this.$api04 + "/Basics/api/Addressee/List";
      post(this.api.url, {
        Page: 1,
        Size: 99999,
      }).then((res) => {
        this.addrConsigneeList = res.Results;
      });
    },

    //检查电话的reg
    checkPhone(CurValue) {
      if (CurValue) {
        let PhoneReg = /^\d{1,}-?\d{1,}$/;
        if (CurValue.match(PhoneReg)) {
          this.PhoneFlag = false;
          return true;
        } else {
          this.PhoneFlag = true;
          return false;
        }
      } else {
        this.PhoneFlag = false;
        return true;
      }
    },
    // ================ 城市和国家下拉的代码，包括获取城市和国家的数据
    //海外国家数据接口
    getCountryInfo() {
      let that = this;
      that.api.param = {};
      that.api.url =
        // that.$api02 + "/api/EbayCustomer/ForeignCity/QueryForeignCountry";
        that.$api04 + "/Basics/api/ForeignCity/QueryForeignCountry";
      fetch(that.api.url, that.api.param).then(function (res) {
        // console.log(res)
        that.countryOptions = res.Results;
      });
    },
    // // 国家值改变
    changeCountryKey(item) {
      this.IsCountry = false;
      this.blurCountry(); //调用国家验证方法
      //国家值改变清空城市下拉数据和城市值
      this.cityOptions = [];
      this.fromConsigneeAddr.Address_City = "";
    },
    checkCity() {
      //城市
      let val = $.trim(this.City);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (!val) {
        this.CityMsg = "Required";
      } else if (val.length > 100) {
        this.CityMsg = "Maximum is 100 characters";
        return false;
      } else if (!regTest.test(val)) {
        this.CityMsg = "English only";
        return false;
      } else {
        this.CityMsg = "";
        return true;
      }
    },
    checkCountry() {
      //国家
      if (!this.fromConsigneeAddr.Country_Key) {
        this.CountryMsg = "Required";
        return false;
      } else {
        this.CountryMsg = "";
        return true;
      }
    },
    checkProvinceName() {
      //街道
      let val = $.trim(this.ProvinceName);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (this.ProvinceName) {
        if (val.length > 100) {
          this.ProvinceNameMsg = "Maximum is 100 characters";
          return false;
        } else if (!regTest.test(val)) {
          this.ProvinceNameMsg = "English only";
          return false;
        } else {
          this.ProvinceNameMsg = "";
          return true;
        }
      } else {
        this.ProvinceNameMsg = "";
        return true;
      }
    },
    checkAddress() {
      //地址
      let val = $.trim(this.Address);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (!val) {
        this.AddressMsg = "Required";
      } else if (val.length > 100) {
        this.AddressMsg = "Maximum is 100 characters";
        return false;
      } else if (!regTest.test(val)) {
        this.AddressMsg = "English only";
        return false;
      } else {
        this.AddressMsg = "";
        return true;
      }
    },
    checkZipCode() {
      //编号
      let val = $.trim(this.ZipCode);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (this.ZipCode) {
        if (val.length > 100) {
          this.ZipCodeMsg = "Maximum is 100 characters";
          return false;
        } else if (!regTest.test(val)) {
          this.ZipCodeMsg = "English only";
          return false;
        } else {
          this.ZipCodeMsg = "";
          return true;
        }
      } else {
        this.ZipCodeMsg = "";
        return true;
      }
    },
    // //收件人城市方法
    remoteMethod(query) {
      if (query != "") {
        this.loading = true;
        this.getCityInfo(query);
      } else {
        this.cityOptions = [];
      }
    },

    // ================

    //发件人input验证方法
    blurConsigCompany() {
      //公司名称
      let val = $.trim(this.fromConsigneeAddr.company);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (!val) {
        this.fromConsigneeAddr.msgCompany = "Required";
      } else if (val.length > 200) {
        this.fromConsigneeAddr.msgCompany = "Maximum is 200 characters";
        return false;
      } else if (!regTest.test(val)) {
        this.fromConsigneeAddr.msgCompany = "English only";
        return false;
      } else {
        this.fromConsigneeAddr.msgCompany = "";
        return true;
      }
    },
    blurConsigContact() {
      //联系人
      let val = $.trim(this.fromConsigneeAddr.Address_Name);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (!val) {
        this.fromConsigneeAddr.msgContact = "Required";
      } else if (val.length > 100) {
        this.fromConsigneeAddr.msgContact = "Maximum is 100 characters";
        return false;
      } else if (!regTest.test(val)) {
        this.fromConsigneeAddr.msgContact = "English only";
        return false;
      } else {
        this.fromConsigneeAddr.msgContact = "";
        return true;
      }
    },

    blurConsigPhone() {
      //联系电话
      let val = $.trim(this.fromConsigneeAddr.Address_Tel);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (!val) {
        this.fromConsigneeAddr.msgPhone = "Required";
      } else if (val.length > 50) {
        this.fromConsigneeAddr.msgPhone = "Maximum is 50 characters";
        return false;
      } else if (!regTest.test(val)) {
        this.fromConsigneeAddr.msgPhone = "English only";
        return false;
      } else {
        this.fromConsigneeAddr.msgPhone = "";
        return true;
      }
    },
    blurConsigEmail() {
      //联系邮箱
      let val = $.trim(this.fromConsigneeAddr.Address_Mail);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (val && val.length > 50) {
        this.fromConsigneeAddr.msgEmail = "Maximum is 50 characters";
        return false;
      } else if (val && !regTest.test(val)) {
        this.fromConsigneeAddr.msgEmail = "English only";
        return false;
      } else {
        this.fromConsigneeAddr.msgEmail = "";
        return true;
      }
    },

    blurCountry() {
      //国家下拉
      let val = $.trim(this.fromConsigneeAddr.Country_Key);
      if (!val) {
        this.fromConsigneeAddr.msgCountry = "Required";
        return false;
      } else {
        this.fromConsigneeAddr.msgCountry = "";
        return true;
      }
    },

    // 保存地址
    saveAddress() {
      var that = this;
      this.checkCity();
      this.checkCountry();
      this.checkProvinceName();
      this.checkAddress();
      this.checkZipCode();
      if (
        this.CityMsg ||
        this.CountryMsg ||
        this.ProvinceNameMsg ||
        this.AddressMsg ||
        this.ZipCodeMsg
      ) {
        return false;
      }
      if (this.fromConsigneeAddr.Country_Key && this.City && this.Address) {
        // 两个必须正确才进行操作
        this.api.url =
          this.$api02 +
          "/api/EbayCustomer/CustomerInfo/UpdateCustomerInfoAdress";
        this.api.param = {
          CountryKey: this.fromConsigneeAddr.Country_Key,
          CityName: this.City,
          ProvinceName: this.ProvinceName,
          ZipCode: this.ZipCode,
          Address: this.Address,
        };
        post(this.api.url, this.api.param).then((res) => {
          if (res.Results) {
            // console.log(res)
            location.reload();
          }
        });
      }
    },
    getUserInfo() {
      let url = this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      post(url, {}).then((res) => {
        if (res.Results) {
          this.UserInfo = res.Results;
          console.log(res, 'res');
          // 判断是否有公司logo
          if (res.Results.CompanyLogoImg) {
            this.companyLogoImg = res.Results.CompanyLogoImg;
            this.$emit('updateCompanyLogo', this.companyLogo);
            this.uploadStatus = 2;
          }
          setCustomer(this.UserInfo); //将客户信息存到session里  如果没有就存
          if (this.UserInfo.RootCustomerID === this.UserInfo.CustomerID) {
            this.isMaster = true;
          }
        }
      });
    },
    GetUsercompy() {
      this.api.url = this.$api02 + "/api/EbayCustomer/CustomerInfo/GetUserInfo";
      this.api.param = {};
      fetch(this.api.url, this.api.param).then((res) => {
        if (res.Results) {
          this.CompyInfo = res.Results;
          this.UserInfo.IsMailVerify = res.Results.IsMailVerify;
        }
      });
    },
    //更新用户信息
    async UpdateUserInfo() {
      let that = this;
      this.checkName();
      if (that.NameMsg || !that.Name || that.PhoneFlag) {
        return false;
      }
      // console.log(that.Name,that.PhoneMsg)
      this.api.url =
        this.$api02 + "/api/EbayCustomer/CustomerInfo/UpdateCustomerInfo";
      this.api.param = {
        Name: this.Name,
        Phone: this.Phone,
      };
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == "C0001") {
          location.reload();
        } else {
          // that.NameMsg = 'duplication of name'
        }
      });
    },
    UpdatePass() {
      let that = this;
      this.checkPassword();
      this.checkPass();
      this.checkPa();
      if (this.checkPa() || this.checkPass() || this.checkPassword()) {
        return false;
      }
      if (this.Passwordxin != this.NewPassword) {
        this.IsPassword3 = true;
        this.PasswordMsg3 = "Password confirmation doesn't match Password";
        return false;
      }
      this.api.url =
        this.$api02 + "/api/EbayCustomer/CustomerInfoPwd/UpdateLogInPwd";
      this.api.param = {
        Password: this.Psaaword,
        NewPassword: this.NewPassword,
      };
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == "C0001") {
          this.$confirm(
            "Success!You have Updated your Password",
            "Change Password",
            {
              customClass: "custom-message-box", //自定义添加Class
              confirmButtonText: "Close",
              cancelButtonText: "取消",
              cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
              closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
              showCancelButton: false, //去掉取消按钮
              showClose: false, //去掉右上角的取消（X）
              // type: 'warning',
              center: true,
            }
          )
            .then(() => {
              this.Psaaword = "";
              this.NewPassword = "";
              this.Passwordxin = "";
              this.IsPassword1 = false;
              this.IsPassword2 = false;
              this.IsPassword3 = false;
              this.IsPassword = false;
              this.showModal = false;
            })
            .catch(() => { });
          return false;
        } else if (res.ErrorCode == "C0002") {
          if (this.Passwordxin == this.NewPassword) {
            this.PasswordMsg = "Current password is not correct";
          } else {
            this.PasswordMsg = "Password modification failed";
          }
          this.PasswordMsg2 = "Password modification failed";
          this.PasswordMsg3 = "Password modification failed";
          this.IsPassword1 = true;
          this.IsPassword2 = true;
        }
      });
    },

    checkPassword() {
      if (this.Psaaword == null || this.Psaaword == "") {
        this.PasswordMsg = "Current password is required";
        this.IsPassword1 = true;
        return true;
      } else {
        this.PasswordMsg1 = "";
        this.IsPassword1 = false;
        return false;
      }
    },
    checkPass() {
      if (this.NewPassword == null || this.NewPassword == "") {
        this.PasswordMsg2 = "New password is required";
        this.IsPassword2 = true;
        return true;
      } else {
        this.PasswordMsg2 = "";
        this.IsPassword2 = false;
        return false;
      }
    },
    checkPa() {
      var reg = /^.{6,20}$/;
      if (this.Passwordxin == null || this.Passwordxin == "") {
        this.IsPassword3 = true;
        this.PasswordMsg3 = "password confirmation is required";
        return true;
      } else {
        this.IsPassword3 = false;
        this.PasswordMsg3 = "";
        if (!reg.test(this.Passwordxin)) {
          //只能输入格式
          this.IsPassword3 = true;
          this.PasswordMsg3 =
            "Please enter 6-20 characters using alphanumeric, numeric or symbolic.";
          return true;
        } else {
          this.IsPassword3 = false;
          this.PasswordMsg3 = "";
          return false;
        }
      }
    },
    checkName() {
      let val = $.trim(this.Name);
      let regTest = /^[^\u4E00-\u9FA5]+$/;
      if (!val) {
        this.NameMsg = "Name is required";
      } else if (val.length > 100) {
        this.NameMsg = "Maximum is 100 characters";
        return false;
      } else if (!regTest.test(val)) {
        this.NameMsg = "English only";
        return false;
      } else {
        this.NameMsg = "";
        return true;
      }
    },
    //修改用户信息

    //关闭弹窗
    GetClose() {
      this.showModal = false;
      this.Account = false;
      this.Edlit = false;
      this.IsPassword = false;
      //关闭修改密码
      this.Psaaword = "";
      this.NewPassword = "";
      this.Passwordxin = "";
      this.IsPassword1 = false;
      this.IsPassword2 = false;
      this.IsPassword3 = false;

      //关闭修改电话
      this.Phone = "";
      this.Name = "";
      this.IsName = false;
    },
    //修改location
    EditLocation() {
      //刚打开时让红框提示不显示，影响美观
      this.IsCity = false;
      this.IsCountry = false;
      this.IsAddress = false;

      this.Address = this.CompyInfo.AddressInfo;
      this.City = this.CompyInfo.CityName;
      this.fromConsigneeAddr.Country_Key = this.CompyInfo.CountryKey;
      this.ZipCode = this.CompyInfo.PostCode;
      this.ProvinceName = this.CompyInfo.ProvincesName;

      this.showModal = true;
      this.Edlit = true;

      this.CountryMsg = "";
      this.CityMsg = "";
      this.ProvinceNameMsg = "";
      this.ZipCodeMsg = "";
      this.AddressMsg = "";
    },
    //修改密码
    UpdatePassword() {
      this.showModal = true;
      this.IsPassword = true;
      this.Password = "";
    },
    //编辑 Account
    EditAccount() {
      this.Name = this.UserInfo.UserName;
      this.Phone = this.CompyInfo.MobilePhone;

      this.showModal = true;
      this.Account = true;
      this.PhoneFlag = false;
    },
    updatePass() {
      this.$refs.updatePass.clkDialog();
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInfo/basicInfo.js